<script>
import {config} from '@/core/config/base'
import {routing} from '@/core/config/routing'
import {http, setBearer} from '@/core/api/headers'
import {formMessages} from '@/core/locale/translation/validation/messages'
import {auth} from '@/core/libs/sessions'
import {messages} from '@/core/locale/translation/http_requests'

export default {
  data: function () {
    return {
      httpRequest: {
        element: [],
        params: '',
        module: null
      },
      waitPlease: false
    }
  },
  methods: {
    get: function (httpRequest) {
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.get(routing[httpRequest.module] + httpRequest.params)
              .then(
                response => {
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  reject(error.response)
                }
              )
          }
        )
      })
    },
    getById: function (id, httpRequest) {
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.get(routing[httpRequest.module] + '/' + id + httpRequest.params)
              .then(
                response => {
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  reject(error.response)
                }
              )
          }
        )
      })
    },
    post: function (httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.post(routing[httpRequest.module] + httpRequest.params, httpRequest.element)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403 || error.response.status === 401) {
                    auth.logout()
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  }
                  reject(error)
                }
              )
          }
        )
      })
    },
    put: function (id, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.put(routing[httpRequest.module] + '/' + id + httpRequest.params, httpRequest.element)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403) {
                    auth.logout()
                    let message = this.messages.filter(msg => error.response.status == msg.code)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = this.messages.filter(msg => error.response.status == msg.code)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    delete: function (id, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        http().then(
          axios => {
            axios.delete(routing[httpRequest.module] + '/' + id)
              .then(
                response => {
                  this.$store.commit('ready')
                  resolve(response.data)
                }
              )
              .catch(
                error => {
                  this.$store.commit('ready')
                  if (error.response.status === 403) {
                    auth.logout()
                    let message = this.messages.filter(msg => error.response.status == msg.code)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.response.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = this.messages.filter(message => message.code == error.response.status)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    formErrorHandler: function (data) {
      this.$store.commit('notificate', {
        title: 'CAMPOS REQUERIDOS',
        text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
        type: 'warn'
      })
      for (var field in data) {
        for (var rule in data[field]) {
          let msg = this.formMessages[rule]
          let fieldError = {
            field: field,
            msg: msg,
            rule: rule
          }
          this.$validator.errors.add(fieldError)
          this.$validator.errors.first(field + ':' + rule)
          setTimeout(() => {
            this.$validator.errors.clear()
          }, 3000)
        }
      }
    },
    upload: function (files, httpRequest) {
      this.$store.commit('wait')
      return new Promise((resolve, reject) => {
        setBearer().then(
          bearer => {
            this.XMLHttpReq(bearer, files, httpRequest)
              .then(
                response => {
                  this.$store.commit('ready')
                  this.$store.commit('notificate', {
                    title: 'ARCHIVO(S) SUBIDO(S)',
                    text: 'El o los archivos fueron subidos correctamente',
                    type: 'success'
                  })
                  resolve(response)
                }
              ).catch(
                error => {
                  console.log(error)
                  this.$store.commit('ready')
                  if (error.status === 403) {
                    auth.logout()
                    let message = this.messages.filter(msg => error.status == msg.code)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  } else if (error.status === 400) {
                    this.formErrorHandler(error.response.data.errors)
                  } else {
                    let message = this.messages.filter(msg => error.status == msg.code)
                    message = message[0]
                    this.$store.commit('notificate', {
                      title: message.title,
                      text: message.text,
                      type: 'error'
                    })
                  }
                }
              )
          }
        )
      })
    },
    XMLHttpReq: function (jwtToken, files, httpRequest) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        let xhr = new XMLHttpRequest()
        for (let index = 0; index < files.target.files.length; index++) {
          formData.append(files.target.name + index, files.target.files[index])
        }
        let params = ''
        if (httpRequest.params && httpRequest.params.length > 0) {
          params = '/' + httpRequest.params
        }
        xhr.open('post', config.api.url + '/' + routing[httpRequest.module] + params, true)
        xhr.setRequestHeader('Authorization', jwtToken)
        xhr.setRequestHeader("Accept", "application/json")
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              resolve(JSON.parse(xhr.response))
            } else {
              reject(xhr)
            }
          }
        }
        xhr.send(formData)
      })
    }
  },
  computed: {
    messages: function () {
      let lang = this.$store.state.lang
      return messages[lang]
    },
    formMessages: function () {
      let lang = this.$store.state.lang
      return formMessages[lang]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/core/api/request.vue